class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.menuSummary = this.querySelector('summary');
    this.menuContent = this.querySelector('.mega-menu__content');
    this.details = this.querySelector('details');

    this.addEventListener('mouseover', this.onMouseOver.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.menuSummary.addEventListener('click', this.onSummaryClick.bind(this));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onMouseOver() {
    this.openMenu();
  }

  onMouseLeave() {
    this.closeMenu();
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeMenu();
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.details.hasAttribute('open') 
      ? this.closeMenu() 
      : this.openMenu();
  }

  onFocusOut(event) {
    const focusedElement = event.relatedTarget;
    if (!this.contains(focusedElement)) {
      this.closeMenu();
    }
  }

  openMenu() {
    this.details.setAttribute('open', '');
    this.menuSummary.setAttribute('aria-expanded', 'true');
  }

  closeMenu() {
    this.details.removeAttribute('open');
    this.menuSummary.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('mega-menu-vrater', MegaMenu); 